import { useEffect, useRef } from "react";

export const HeadMeshStatic = ({ imageUrl, maskUrl, width, height }) => {
  const canvasRef = useRef();
  const imgRef = useRef();

  useEffect(() => {
    if (!maskUrl) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = width;
    canvas.height = height;

    const maskImg = new Image();
    const textureImg = new Image();

    maskImg.src = maskUrl;
    textureImg.src = "Mesh.png";

    Promise.all([
      new Promise((res) => (maskImg.onload = res)),
      new Promise((res) => (textureImg.onload = res)),
    ]).then(() => {
      ctx.clearRect(0, 0, width, height);

      ctx.drawImage(maskImg, 0, 0, width, height);
      const imgData = ctx.getImageData(0, 0, width, height);
      const data = imgData.data;

      for (let i = 0; i < data.length; i += 4) {
        const brightness = data[i]; // red channel (since B/W)
        data[i + 3] = brightness;
      }

      ctx.putImageData(imgData, 0, 0);

      ctx.globalCompositeOperation = "source-in";
      const pattern = ctx.createPattern(textureImg, "repeat");
      ctx.fillStyle = pattern;
      ctx.fillRect(0, 0, width, height);
      ctx.globalCompositeOperation = "source-over";
    });
  }, [maskUrl, width, height]);

  return (
    <div
      style={{ position: "relative", display: "inline-block", height: "100%" }}
    >
      <img
        ref={imgRef}
        src={imageUrl}
        width={100}
        alt="Mesh"
        style={{
          display: "absolute",
          left: 0,
          top: 0,
          objectFit: "cover",
          width: "100%",
          height: "100%",
          transform: "scaleX(-1)",
        }}
      />
      {maskUrl !== "" && (
        <canvas
          ref={canvasRef}
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            objectFit: "cover",
            pointerEvents: "none",
            placeItems: "center",
            opacity: 0.6,
            transform: "scaleX(-1)",
          }}
        />
      )}
    </div>
  );
};
